export default {"src":"/_next/static/media/LPX.c98a7b3b.svg","height":18,"width":18};